export default function chinhSachVanChuyen() {
  return (
    <div className="container chinh-sach mt-6">
      <div className="chinh-sach-van-cuyen list-chinhsach px-4">
        <h4 className="text-center text-uppercase">Chính sách vận chuyển</h4>
        <p className="mb-3">
          <span>
            Nhằm hỗ trợ vận chuyển sản phẩm tới tận tay khách hàng đảm bảo nhất,
            Giga Digital cung cấp chính sách vận chuyển như sau:
          </span>
        </p>
        <blockquote className="mb-3">
          <p>1. Hình thức, thời gian vận chuyển</p>
        </blockquote>

        <ul className="list-unstyled">
          <li>
            - Tại khu vực công ty có tuyến giao hàng trực tiếp, Giga Digital sẽ
            giao hàng cho khách hàng tại địa chỉ khách hàng đã đăng ký
          </li>
          <li>
            - Tại những khu vực khác công ty sẽ vận chuyển thông qua các đơn vị
            dịch vụ vận chuyển
          </li>
          <li>
            - Miễn phí giao hàng toàn quốc đối với tất cả các đơn hàng có tổng
            hóa đơn trên 2.000.000VNĐ
          </li>
          <li>- Thời gian vận chuyển trung bình: 3-7 ngày</li>
        </ul>
        <br />
        <strong>Lưu ý: </strong>
        <ul className="list-unstyled">
          <li>
            - Đối với những sản phẩm cần lắp đặt thì thời gian giao hàng sẽ được
            thỏa thuận với khách hàng
          </li>
          <li>
            - Những trường hợp kéo dài thời gian giao hàng do tình huống bất khả
            kháng như sau:
          </li>
          <li>+ Không thể liên hệ với khách hàng</li>
          <li>+ Địa chỉ giao hàng không chính xác hoặc khó tìm kiếm</li>
          <li>
            + Số lượng đơn hàng tăng đột biến khiến việc xử lý đơn hàng bị chậm,
            thông thường xảy ra vào đợt mua sắm cao điểm như: ngày sale, Black
            Friday,...
          </li>
          <li>
            + Trường hợp thiên tai, dịch bệnh, điều kiện thời tiết khắc
            nghiệt... đơn hàng cũng có thể được giao chậm hơn thông thường
          </li>
        </ul>
        <br />
        <blockquote className="mb-3">
          <p>2. Chính sách lắp đặt</p>
        </blockquote>

        <ul className="list-unstyled">
          <li>
            - Giga Digital thực hiện việc lắp đặt/ thi công sản phẩm tận nơi
            theo yêu cầu của khách hàng
          </li>
          <li>
            - Phí lắp đặt có thể miễn phí hoặc tính phí tùy thuộc vào loại sản
            phẩm
          </li>
          <li>
            - Đối với sản phẩm yêu cầu sử dụng kỹ thuật hoặc phần mềm vận hành
            riêng của Giga Digital, chúng tôi sẽ cung cấp để đảm bảo độ an toàn
            và chất lượng. Trường hợp khách hàng tự lắp đặt sản phẩm, cài đặt
            phần mềm thì khách hàng phải chịu trách nhiệm về kỹ thuật cũng như
            mọi rủi ro liên quan đến sản phẩm và con người.
          </li>
          <li>
            - Với những đơn hàng dịch vụ sửa chữa sẽ tùy thuộc vào đặc điểm của
            yêu cầu, công ty sẽ áp dụng 2 hình thức sửa chữa như sau: sửa chữa
            tận nơi hoặc chuyển về kho của công ty.
          </li>
        </ul>
        <br />
        <blockquote className="mb-3">
          <p>3. Trách nhiệm với hàng hóa vận chuyển</p>
        </blockquote>

        <ul className="list-unstyled">
          <li>
            - Tất cả sản phẩm đều được đóng gói kĩ lưỡng, dán tem niêm phong đầy
            đủ
          </li>
          <li>
            - Quý khách có trách nhiệm quay video bóc hộp đầy đủ và kiểm tra
            hàng hóa ngay khi nhận hàng. Khi phát hiện hàng hóa bị hư hại, trầy
            xước, bể vỡ, móp méo, hoặc sai hàng hóa thì báo ngay với nhân viên
            giao hàng và công ty để giải quyết kịp thời.
          </li>
        </ul>
      </div>
    </div>
  );
}
